var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.864746,
    y: 0.668945,
    width: 24,
    height: 23,
    rx: 7.5,
    fill: "#ECFDF6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.864746,
    y: 0.668945,
    width: 24,
    height: 23,
    rx: 7.5,
    stroke: "#CEF5E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6772 9.08301C17.9116 9.31738 17.9116 9.66895 17.6772 9.87988L11.4897 16.0674C11.2788 16.3018 10.9272 16.3018 10.7163 16.0674L7.52881 12.8799C7.29443 12.6689 7.29443 12.3174 7.52881 12.083C7.73975 11.8721 8.09131 11.8721 8.30225 12.083L11.1147 14.8955L16.9038 9.08301C17.1147 8.87207 17.4663 8.87207 17.6772 9.08301Z",
    fill: "#047857"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIcon);
export default __webpack_public_path__ + "static/media/CheckedIcon.f1d829def37121eaf3cd70f63b7d0993.svg";
export { ForwardRef as ReactComponent };